export default "__VITE_ASSET__WqiSagOY__"